import { render, staticRenderFns } from "./LostRecordResultList.vue?vue&type=template&id=50072b5b&scoped=true&"
import script from "./LostRecordResultList.vue?vue&type=script&lang=js&"
export * from "./LostRecordResultList.vue?vue&type=script&lang=js&"
import style0 from "./LostRecordResultList.vue?vue&type=style&index=0&id=50072b5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50072b5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDataTable,VImg,VRow})
